if (!customElements.get('variant-products-select')) {
  class VariantProductsSelect extends HTMLElement {
    connectedCallback() {
      this.changeHandler = this.handleChange.bind(this);
      this.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.changeHandler);
    }

    /**
     * Handles 'change' events dispatched by the inner custom select.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      if (evt.detail && evt.detail.productUrl) {
        window.location.assign(evt.detail.productUrl);
      }
    }
  }

  customElements.define('variant-products-select', VariantProductsSelect);
}
